<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="filter-input-v2" :dir="isRTLView ? 'rtl' : 'ltr'">
    <div
      class="rounded-xl p-3 border border-solid"
      :class="getInputErrorClass(v.values.$dirty, v.values.$error)"
    >
      <div class="flex flex-row items-start gap-4 text-gray-800">
        <div
          v-if="showFilterType"
          class="flex flex-col max-w-[30%] w-full gap-1.5"
        >
          <span v-if="showInputLabel" class="text-sm">
            {{ $t('FILTER.FIELD') }}
          </span>
          <woot-multiselect
            v-if="groupedFilters"
            ref="multiselect"
            v-model="selectedFilterType"
            :options="filterTypeOptions"
            group-label="groupName"
            group-values="options"
            track-by="id"
            label="name"
            :max-height="250"
            :show-labels="false"
            :allow-empty="false"
            :placeholder="$t('FILTER.SELECT_PLACEHOLDER')"
            class="filter-multiselect w-full no-margin"
            @open="pinDropdown"
          />
          <woot-multiselect
            v-if="!groupedFilters"
            v-model="selectedFilterType"
            :options="flatFilterOptions"
            track-by="id"
            label="name"
            :show-labels="false"
            :allow-empty="false"
            :placeholder="$t('FILTER.SELECT_PLACEHOLDER')"
            class="filter-multiselect w-full no-margin"
            @open="pinDropdown"
          />
        </div>

        <div
          v-if="showFilterOperator"
          class="flex flex-col max-w-[20%] w-full gap-1.5"
        >
          <span v-if="showInputLabel" class="text-sm"> &nbsp; </span>
          <woot-multiselect
            v-model="selectedOperator"
            :options="operators"
            track-by="value"
            :show-labels="false"
            :allow-empty="false"
            :custom-label="operatorLabel"
            :searchable="false"
            class="filter-multiselect w-full no-margin"
            :placeholder="$t('FILTER.SELECT_PLACEHOLDER')"
            @open="pinDropdown"
          />
        </div>

        <div
          v-if="showUserInput"
          class="filter__answer--wrap flex-grow flex flex-col gap-1.5"
        >
          <span v-if="showInputLabel" class="text-sm">
            {{ $t('FILTER.VALUE') }}
          </span>
          <input
            v-if="booleanFilterOperator"
            v-model="values"
            type="text"
            class="mb-0"
            :placeholder="$t('FILTER.VALUE_PLACEHOLDER')"
            :disabled="true"
          />
          <div
            v-else-if="inputType === 'multi_select'"
            class="multiselect-wrap--small"
          >
            <woot-multiselect
              ref="multiselector"
              v-model="values"
              track-by="id"
              label="name"
              :placeholder="$t('FILTER.SELECT_PLACEHOLDER')"
              :search-placeholder="$t('FILTER.SEARCH_PLACEHOLDER')"
              :multiple="true"
              selected-label
              :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
              deselect-label=""
              :max-height="250"
              :options="dropdownValues"
              :allow-empty="true"
              :show-labels="false"
              class="no-margin"
            />
          </div>
          <div
            v-else-if="inputType === 'search_select'"
            class="multiselect-wrap--small"
          >
            <woot-multiselect
              v-model="values"
              track-by="id"
              label="name"
              :placeholder="$t('FILTER.SELECT_PLACEHOLDER')"
              selected-label
              :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
              deselect-label=""
              :max-height="250"
              :options="dropdownValues"
              :allow-empty="false"
              :option-height="104"
              :show-labels="false"
              class="no-margin"
              @open="pinDropdown"
            />
          </div>
          <div v-else-if="inputType === 'date'" class="multiselect-wrap--small">
            <date-picker
              v-model="values"
              type="date"
              format="DD-MM-YYYY"
              value-type="DD-MM-YYYY"
              class="w-full"
              input-class="mb-0"
            />
          </div>
          <div v-else-if="inputType === 'date_range'" class="w-full">
            <date-range-picker v-model="values" />
          </div>
          <input
            v-else
            v-model="values"
            type="text"
            class="mb-0"
            :placeholder="$t('FILTER.VALUE_PLACEHOLDER')"
          />
        </div>
        <div class="flex flex-col gap-1.5 w-fit">
          <span v-if="showInputLabel" class="text-sm">&nbsp;</span>
          <span
            v-tooltip.top="{
              content: disableRemoveFilter
                ? $t('FILTER.REMOVE_FILTER_TOOLTIP')
                : undefined,
              classes: ['w-fit', '!z-[9999]', 'text-nowrap', 'max-w-full'],
            }"
          >
            <button
              class="button button-ghost h-[44px]"
              :disabled="disableRemoveFilter"
              @click="removeFilter"
            >
              <svg
                width="15"
                height="17"
                viewBox="0 0 15 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.80775 16.8845C2.30908 16.8845 1.88308 16.7079 1.52975 16.3547C1.17658 16.0014 1 15.5754 1 15.0768V2.3845H0V0.8845H4.5V0H10.5V0.8845H15V2.3845H14V15.0768C14 15.5819 13.825 16.0095 13.475 16.3595C13.125 16.7095 12.6974 16.8845 12.1923 16.8845H2.80775ZM12.5 2.3845H2.5V15.0768C2.5 15.1666 2.52883 15.2403 2.5865 15.298C2.64417 15.3557 2.71792 15.3845 2.80775 15.3845H12.1923C12.2692 15.3845 12.3398 15.3524 12.4038 15.2883C12.4679 15.2243 12.5 15.1538 12.5 15.0768V2.3845ZM4.904 13.3845H6.40375V4.3845H4.904V13.3845ZM8.59625 13.3845H10.096V4.3845H8.59625V13.3845Z"
                  :fill="disableRemoveFilter ? '#a3a3a3' : '#ef4444'"
                />
              </svg>
            </button>
          </span>
        </div>
      </div>
      <p v-if="v.values.$dirty && v.values.$error" class="filter-error">
        {{ $t('FILTER.EMPTY_VALUE_ERROR') }}
      </p>
    </div>

    <div
      v-if="showQueryOperator"
      class="flex items-center justify-center relative my-2.5 mx-0"
    >
      <hr
        class="w-full absolute border-b border-solid border-gray-200 dark:border-slate-800"
      />
      <div class="flex relative bg-white px-2.5 gap-2">
        <button
          v-for="queryOperator in queryOperators"
          :key="queryOperator.value"
          type="button"
          class="flex h-11 w-[62px] items-center justify-center rounded-[8px] border border-solid border-gray-300 text-base font-normal leading-6 cursor-pointer transition-colors"
          :class="
            query_operator === queryOperator.value
              ? 'text-neutral-50'
              : 'bg-white text-gray-500 hover:border-gray-400'
          "
          :style="
            query_operator === queryOperator.value
              ? 'background-color: #000000'
              : ''
          "
          @click="query_operator = queryOperator.value"
        >
          {{ $t(queryOperator.label) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import DateRangePicker from './DateRangePicker.vue';
import filterInputMixin from './filterInputMixin';
import rtlMixin from 'shared/mixins/rtlMixin';

export default {
  components: {
    DatePicker,
    DateRangePicker,
  },
  mixins: [filterInputMixin, rtlMixin],
  props: {
    showInputLabel: {
      type: Boolean,
      default: false,
    },
    disableRemoveFilter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filterTypeOptions() {
      return this.filterGroups.map(group => ({
        groupName: group.name,
        options: group.attributes.map(attr => ({
          id: attr.key,
          name: attr.name,
        })),
      }));
    },
    flatFilterOptions() {
      return this.filterAttributes.map(attr => ({
        id: attr.key,
        name: attr.name,
        $isDisabled: attr.disabled,
      }));
    },
    selectedFilterType: {
      get() {
        if (this.groupedFilters) {
          const allOptions = this.filterTypeOptions.flatMap(
            group => group.options
          );
          return (
            allOptions.find(opt => opt.id === this.attributeKey) ||
            allOptions[0] ||
            null
          );
        }
        return (
          this.flatFilterOptions.find(opt => opt.id === this.attributeKey) ||
          this.flatFilterOptions[0] ||
          null
        );
      },
      set(option) {
        this.attributeKey = option ? option.id : null;
        this.resetFilter();
      },
    },
    selectedOperator: {
      get() {
        return (
          this.operators.find(opt => opt.value === this.filterOperator) ||
          this.operators[0] ||
          null
        );
      },
      set(option) {
        this.filterOperator = option.value;
      },
    },
  },
  methods: {
    pinDropdown() {
      this.$nextTick(() => {
        const active = this.$el.querySelector('.multiselect--active');
        if (!active) return;
        const wrapper = active.querySelector('.multiselect__content-wrapper');
        if (!wrapper) return;
        const rect = active.getBoundingClientRect();
        wrapper.style.position = 'fixed';
        wrapper.style.width = `${rect.width}px`;
        wrapper.style.left = `${rect.left}px`;
        wrapper.style.zIndex = '10000';
        const listHeight = Math.min(wrapper.scrollHeight || 200, 300);
        const spaceBelow = window.innerHeight - rect.bottom;
        const openUp = spaceBelow < listHeight + 8 && rect.top > spaceBelow;
        if (openUp) {
          wrapper.style.top = 'auto';
          wrapper.style.bottom = `${window.innerHeight - rect.top + 4}px`;
        } else {
          wrapper.style.bottom = 'auto';
          wrapper.style.top = `${rect.bottom + 4}px`;
        }
      });
    },
    operatorLabel(item) {
      if (!item)
        return this.$t(`FILTER.OPERATOR_LABELS.${this.operators[0].value}`);
      return this.$t(`FILTER.OPERATOR_LABELS.${item.value}`);
    },
    getInputErrorClass(isDirty, hasError) {
      return isDirty && hasError
        ? 'filter-input-error'
        : 'bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700/50';
    },
  },
};
</script>
<style lang="scss" scoped>
.filter__answer--wrap {
  input {
    @apply bg-white min-h-[44px] rounded-[8px] disabled:opacity-75 dark:bg-slate-900 mb-0 text-slate-800 dark:text-slate-100 border-gray-300 dark:border-slate-600 px-3 py-[8px];

    &:hover {
      @apply border-gray-400;
    }

    &:focus {
      @apply border-gray-400;
    }
  }
}
.filter-error {
  @apply text-[#b91c1c];
}

::v-deep {
  .filter-input-error {
    .mx-input-wrapper {
      input {
        border-color: #b91c1c !important;
      }
    }

    .filter-error {
      @apply text-[#b91c1c];
    }
  }

  .mx-input-wrapper {
    input {
      @apply border-gray-300 hover:border-gray-400 text-gray-800 min-h-[44px] rounded-[8px] px-3 py-[8px];

      &:not(:placeholder-shown) {
        @apply border-gray-400;
      }
    }

    .mx-icon-calendar {
      right: 12px;
    }
  }
}
</style>
